<template>
  <!-- eslint-disable vue/no-lone-template -->
  <div class="col-6 contact-topic d-flex flex-column">
    <div v-if="contact && contact.contactId" class="topic col p-0">
      <div class="topic-head fixed">
        <div class="media">
          <div class="media-body">
            <div class="contact-header">
              {{ contact.contactId | contact_id }}
              {{ contact.contactCategory.title }}
            </div>
            <div class="contact-time">
              {{ contact.createdAt | momentFull }}
            </div>
          </div>
          <div class="ms-3">
            <div class="actions">
              <button
                v-if="contact.closedAt === null"
                class="btn-primary pointer close-case float-end mt-1"
                @click="dialogShow = true"
              >
                ปิดเคส
              </button>
              <span v-else class="case-closed float-end mt-2"
                >ปิดเคสแล้ว</span
              >
              <confirm-dialog
                v-show="dialogShow"
                :data="dialogData"
                @confirm="contactConfirm"
              ></confirm-dialog>
            </div>
          </div>
        </div>
      </div>
      <div class="scrolling">
        <div class="topic-title">
          <div class="media">
            <div class="me-2">
              <img :src="contact.profileImage" class="topic-icon" alt />
            </div>
            <div class="media-body">
              <div class="contact-header">
                {{ contactTopicPersonName }}
              </div>
              <div class="contact-detail" style="white-space: pre-line">
                {{ contact.topic.detail }}
              </div>
              <div class="contact-detail-image">
                <sc-thumbnail
                  v-for="topicImage in visibleTopicImages"
                  :key="topicImage.image"
                  :img-src="topicImage.image"
                  :img-class="'topic-image'"
                ></sc-thumbnail>
              </div>
            </div>
            <div class="ms-3">
              <div class="topic-head-right">
                {{ contact.createdAt | momentFull }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="topicReplies && topicReplies.rows" class="topic-replies">
          <div
            v-if="totalWebReply < totalReply"
            class="topic-reply-more"
            @click="getReplies()"
          >
            โหลดบทสนทนาที่เก่ากว่า
          </div>
          <div
            v-for="reply in topicReplies.rows"
            :key="reply.topicReplyId"
            :class="{ 'new-message': reply.new }"
            class="media topic-reply"
          >
            <div class="me-2">
              <img :src="reply.profileImage" class="topic-icon" alt />
            </div>
            <div class="media-body">
              <div class="contact-header">
                <div class="media">
                  <div class="media-body">
                    {{
                      reply.createdByUser && reply.createdByUser.firstName
                        ? reply.createdByUser.firstName +
                          " " +
                          reply.createdByUser.lastName
                        : reply.createdByAdmin &&
                            reply.createdByAdmin.firstName &&
                            reply.createdByAdmin.deletedAt
                          ? reply.createdByAdmin.firstName +
                            " " +
                            reply.createdByAdmin.lastName +
                            " (DELETED)"
                          : reply.createdByAdmin &&
                              reply.createdByAdmin.firstName
                            ? reply.createdByAdmin.firstName +
                              " " +
                              reply.createdByAdmin.lastName
                            : "ADMIN SCASSET"
                    }}
                  </div>
                </div>
              </div>
              <div class="contact-detail" style="white-space: pre-line">
                <div>{{ reply.message }}</div>
              </div>
              <div class="contact-detail-image">
                <template v-if="reply.imageKey">
                  <sc-thumbnail
                    v-for="(replyImage, indexImage) in reply.imageKey"
                    :key="indexImage"
                    :img-src="replyImage[0]"
                    :img-class="'topic-image'"
                  ></sc-thumbnail>
                </template>
              </div>
              <div class="contact-detail-pdf">
                <file-pdf
                  v-if="reply.pdfKey"
                  :file-src="reply.pdfKey"
                  :file-name="reply.pdfName"
                ></file-pdf>
              </div>
            </div>
            <div class="ms-2 text-end">
              <div class="topic-head-right">
                {{ reply.createdAt | momentFull }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <reply-box
          v-if="contact.closedAt === null"
          :contact-id="contactId"
          :home-id="contact.homeId"
          @message-send-success="onMessageSendSuccess"
          @message-send-fail="onMessageSendFail"
          @confirm-image="onImageLarge"
        ></reply-box>
      </div>
    </div>
    <confirm-dialog
      v-show="confirmImage"
      :data="confirmImageData"
      @confirm="confirmImage = false"
    ></confirm-dialog>
  </div>
</template>

<script>
import axios from "axios"
import Thumbnail from "@/components/helper/Thumbnail"
import ReplyBox from "@/components/admin/view/contact/ReplyBox"
import FilePDF from "@/components/helper/FilePDF"
import { getCookie, Auth } from "@/lib/cookie"
import { getMessagingIfSupported } from "@/setup/firebaseMessaging"
import { onMessage } from "firebase/messaging"

export default {
  components: {
    "sc-thumbnail": Thumbnail,
    "file-pdf": FilePDF,
    ReplyBox,
  },
  props: {
    contact: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      contactId: this.$route.params.contactId,
      contactClose: false,
      currentContact: this.contact,
      dialogData: {
        title: "ยืนยันการปิดรายการ",
        detail: "คุณต้องการปิดเคสนี้ใช่หรือไม่",
        buttonCancel: "ยกเลิก",
        buttonSubmit: "ยืนยัน",
      },
      dialogShow: false,
      confirmImageData: {
        title: "รูปขนาดเกิน 1 MB ไม่สามารถอัพโหลดได้",
        buttonSubmit: "ยืนยัน",
      },
      confirmImage: false,
      confirmPDF: false,
      image: null,
      pdf: null,
      messageDisable: false,
      newMessagePosition: 0,
      topicReplies: {
        rows: [],
      },
      currentPage: 1,
      topicReplyTemplates: null,
      topicReplyTemplatesShow: false,
      totalReply: 0,
      totalWebReply: 0,
      lastReply: new Date().toISOString(),
      defaultAdminIcon: "/static/icons/sc-profile-default.png",
      defaultUserIcon: "/static/icons/user-profile-default.png",
      unsubscribeMessage: null,
      allConversationImage: [],
      isDestroyed: false,
    }
  },
  computed: {
    topicImages() {
      if (
        !this.contact ||
        !this.contact.topic ||
        !this.contact.topic.topic_images ||
        this.contact.topic.topic_images.length === 0
      )
        return undefined

      const topicImages = this.contact.topic.topic_images.filter(
        (image) => !image.topicReplyId,
      )

      if (topicImages.length === 0) return undefined

      return topicImages
    },
    visibleTopicImages() {
      if (!this.topicImages) {
        return []
      }

      return this.topicImages.filter((image) => image)
    },
    contactTopicPersonName() {
      let topicPersonName = "ADMIN SCASSET"
      if (
        !this.contact.topic ||
        (!this.contact.topic.createdByUser &&
          !this.contact.topic.createdByAdmin)
      ) {
        topicPersonName = "ADMIN SCASSET"
      } else if (this.contact.topic.createdByUser) {
        const { createdByUser } = this.contact.topic

        topicPersonName = `${createdByUser.firstName || ""} ${createdByUser.lastName || ""}`
      } else if (this.contact.topic.createdByAdmin) {
        const { createdByAdmin } = this.contact.topic

        const adminName = `${createdByAdmin.firstName || ""} ${createdByAdmin.lastName || ""}`

        topicPersonName = createdByAdmin.deletedAt
          ? `${adminName} (DELETED)`
          : adminName
      }

      return topicPersonName
    },
  },
  watch: {
    async $route(to) {
      if (to.params.contactId) {
        this.contactId = this.$route.params.contactId
        this.currentPage = 1
        this.lastReply = new Date().toISOString()
        this.topicReplies = { rows: [] }

        await this.getReplies(to.params.contactId)

        this.contactId = to.params.contactId
      }
    },
  },
  async mounted() {
    if (this.contactId && this.contactId !== "all") {
      this.getReplies(this.contactId)
    }

    const messaging = await getMessagingIfSupported()

    if (messaging && !this.isDestroyed) {
      this.unsubscribeMessage = onMessage(messaging, (payload) => {
        const vm = this

        if (
          payload.data.targetFeature === "CONVERSATION" &&
          payload.data.targetAction === "REPLY" &&
          `${vm.contactId}` === payload.data.targetId &&
          payload.data.adminId !== localStorage.getItem("adminId")
        ) {
          const newReply = {
            adminId: payload.data.adminId,
            userId: payload.data.userId,
            createdAt: new Date(),
            createdByAdmin: {
              firstName: payload.data.adminFirstName,
              lastName: payload.data.adminLastName,
            },
            createdByUser: {
              firstName: payload.data.userFirstName,
              lastName: payload.data.userLastName,
              imageKey: payload.data.userImageKey,
            },
            message: payload.notification.body,
            profileImage: "",
            imageKey: payload.data.messageImageKey,
            image: "",
            topicReplyId: payload.data.targetId,
          }

          if (payload.data.userImageKey) {
            this.getImage(payload.data.userImageKey).then((resImage) => {
              if (resImage) {
                newReply.profileImage = resImage
              }
            })
          }

          if (payload.data.messageImageKey) {
            this.getImage(payload.data.messageImageKey).then((resImage) => {
              if (resImage) {
                newReply.image = resImage
              }
            })
          }

          if (newReply.userId && !newReply.profileImage)
            newReply.profileImage = vm.defaultUserIcon
          else if (newReply.adminId) newReply.profileImage = vm.defaultAdminIcon

          vm.topicReplies.rows.push(newReply)

          setTimeout(() => {
            const repliesElement = document.querySelectorAll(".topic-reply")
            if (repliesElement && repliesElement[repliesElement.length - 1]) {
              repliesElement[repliesElement.length - 1].scrollIntoView()
            }
          }, 200) // wait for DOM to be rendered
        }
      })
    } else {
      // eslint-disable-next-line no-console
      console.debug("Could not init push notification listener")
    }
  },
  beforeDestroy() {
    this.isDestroyed = true

    if (this.unsubscribeMessage) {
      this.unsubscribeMessage()
    }
  },
  methods: {
    async getReplies(contactId = this.contactId) {
      const vm = this

      this.lastReply =
        vm.topicReplies &&
        vm.topicReplies.rows &&
        vm.topicReplies.rows.length > 0
          ? vm.topicReplies.rows[0].created_at
          : undefined

      await axios
        .get(`${process.env.HOST}/admin/conversations/${contactId}/replies`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
          },
          params: { before: this.lastReply },
        })
        .then(async (res) => {
          const existReplies = vm.topicReplies.rows
          const replies = res.data.rows

          const currentReplies = await Promise.all(
            replies.map(async (val) => {
              // get profile image
              let profileImage
              if (!val.createdByUser) {
                profileImage = vm.defaultAdminIcon
              } else if (val.createdByUser.imageKey === null) {
                profileImage = vm.defaultUserIcon
              } else if (val.createdByUser.imageKey) {
                this.getImage(val.createdByUser.imageKey).then((resImage) => {
                  profileImage = resImage
                })
              }

              // get reply images
              // PROBLEM: sometime variable is image_key OR imageKey (legacy code)
              // imageKey type is array in array
              let imageKey = []
              if (val.image_key || val.imageKey) {
                const imageKeyTopicReply = val.image_key
                  ? val.image_key
                  : val.imageKey

                await this.getImage(imageKeyTopicReply).then((resImage) => {
                  imageKey.push([resImage])
                })
              } else if (val.topic_images) {
                imageKey = val.topic_images.map((image) => {
                  const imageArray = []
                  this.getImage(image.image_key).then((resImage) => {
                    imageArray.push(resImage)
                  })

                  return imageArray
                })
              }

              // get reply pdf
              const pdf = val.pdfKey || val.pdf_key
              const pdfKey = pdf ? await this.getPDF(pdf) : undefined

              const pdfName = val.pdfName || val.pdf_name

              return {
                ...val,
                profileImage,
                pdfKey,
                imageKey,
                createdAt:
                  val.created_at || val.createdAt || new Date().toISOString(),
                pdfName,
              }
            }),
          )

          this.topicReplies.rows = [...currentReplies, ...existReplies]

          vm.lastReply =
            this.topicReplies.rows.length > 0 &&
            this.topicReplies.rows[0].created_at
              ? this.topicReplies.rows[0].created_at
              : new Date().toISOString()

          vm.totalReply = res.data.total
          vm.totalWebReply = replies.length

          setTimeout(() => {
            const repliesElement = document.querySelectorAll(".topic-reply")
            if (
              repliesElement &&
              repliesElement[repliesElement.length - existReplies.length - 1]
            ) {
              repliesElement[
                repliesElement.length - existReplies.length - 1
              ].scrollIntoView()
            }
          }, 200) // wait for DOM to be rendered
        })
    },
    contactConfirm(action) {
      if (action === true) {
        axios
          .post(
            `${process.env.HOST}/admin/conversations/${
              this.contact.contactId
            }/close`,
            {},
            {
              headers: {
                Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
              },
            },
          )
          .then(() => {
            this.$emit("closeCase")
          })
          .catch((e) => {
            throw e
          })
      }

      this.dialogShow = false
    },
    getProfileIcon(data) {
      if (!data.createdByUser) {
        return this.defaultAdminIcon
      }

      if (data.createdByUser.imageKey === null) {
        return this.defaultUserIcon
      }

      return this.getImage(data.createdByUser.imageKey)
    },
    async getImage(imageKey) {
      try {
        const resImage = await axios.get(
          `${process.env.HOST}/api/downloads/image`,
          {
            params: {
              imageKey,
            },
          },
        )

        return resImage.data.url
      } catch (error) {
        // eslint-disable-next-line no-console
        console.debug("Download image failed with key:", imageKey)
        return null
      }
    },
    async getPDF(pdfKey) {
      try {
        const resPDF = await axios.get(
          `${process.env.HOST}/api/downloads/file`,
          {
            params: {
              fileKey: pdfKey,
              feature: "topic",
              contentType: "application/pdf",
            },
          },
        )

        return resPDF.data.url
      } catch (error) {
        // eslint-disable-next-line no-console
        console.debug("Download pdf failed with key:", pdfKey)
        return null
      }
    },
    async onMessageSendSuccess() {
      await this.getReplies()

      await this.$router.push({
        name: "Contact",
        params: { contactId: this.contactId },
        query: { reply: "successful" },
      })
    },
    onMessageSendFail() {},

    async clearBadges() {
      await axios.put(
        `${process.env.HOST}/admin/conversations/${
          this.contact.contactId
        }/clearBadges`,
        {},
        {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
          },
        },
      )
    },
    onImageLarge(value) {
      this.confirmImage = value
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  margin-top: 10px;

  &-icon {
    width: 36px;
    height: 36px;
    background-color: $white;
    border-radius: 15px;
  }

  .list-group-item {
    background-color: rgba(224, 224, 224, 0.5);
    padding: 7px;

    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.1px;
    text-align: left;
    color: $black;
  }
}
.pdf-box {
  height: 70px;
  border-bottom: 1px solid #f5f5f5;
}
.topic {
  background-color: #f9f9f9;
  display: flex;
  flex: auto;
  flex-direction: column;
  height: calc(100vh - 110px);

  &-head,
  &-title,
  &-reply {
    border-bottom: solid 1px #e0e0e0;
    padding: 12px 25px 10px 20px;
    background-color: $white;
  }
  &-reply {
    &-more {
      text-align: center;
      font-size: 12px;
      padding: 2px;
      cursor: pointer;
      transition:
        background-color 1s ease,
        color 1s ease;

      &:hover {
        background-color: #eee;
        color: $black;
      }
    }
    &.new-message {
      position: relative;

      &::before {
        content: "New Message";
        display: block;
        position: absolute;
        background-color: $blue;
        font-size: 10px;
        font-weight: bold;
        color: $white;
        border-radius: 2em;
        bottom: -8px;
        left: 44%;
        padding: 2px 8px;
        z-index: 1;
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        border-bottom: 1px solid $blue;
        bottom: 0;
        left: 0;
      }
    }
  }
  &-head-right {
    font-size: 11px;
    font-weight: 500;
    text-align: right;
    color: #8c8786;
    text-align: right;
    line-height: 1.64;
    letter-spacing: -0.1px;
  }
  &-icon {
    width: 32px;
    height: 32px;
    border-radius: 9px;
    background-color: #eeeeee;
    border: solid 1px $white;
  }
  &-image {
    width: 90px;
    height: 90px;
    border-radius: 15px;
    background-color: #e0e0e0;
    float: left;
    position: relative;
    margin: 16px 10px 10px 10px;
  }
  &-right {
    opacity: 0.5;
    font-size: 14px;
    font-weight: bold;
    text-align: right;
    color: $black;
    margin-right: 25px;
  }
  &-title,
  &-reply {
    border-bottom: solid 1px #f5f5f5;
    padding-top: 15px;
    padding-bottom: 15px;
  }
}

.scrolling {
  display: flex;
  flex: auto;
  overflow-y: auto;
  flex-grow: 1;
  flex-flow: column;
}
.input-actions {
  border-bottom: 1px solid #f5f5f5;
  padding: 4px;
}
.actions .case-closed {
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
  text-align: right;
  color: $red;
}
</style>
